const LSID_KEY = 'zapp_lsid'

// Minimal UUID v4 fallback — kept tiny to avoid large bundles and not rely on platform crypto.
const uuidv4Fallback = (): string =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16)
    // for 'y' we need a value in 8..11 — compute without bitwise ops
    const v = c === 'x' ? r : (r % 4) + 8
    return v.toString(16)
  })

type WindowRecord = Window & Record<string, string>

export const getOrCreateLSID = (): string => {
  try {
    const existing = window.localStorage.getItem(LSID_KEY)
    if (existing) return existing

    // Use the compact fallback always (do not depend on crypto.randomUUID)
    const raw = uuidv4Fallback()

    const id = String(raw).toUpperCase()
    const value = `uuid:${id}`
    window.localStorage.setItem(LSID_KEY, value)
    return value
  } catch (e) {
    // localStorage might be blocked; fall back to an in-memory value on window for the page session
    const winKey = `__${LSID_KEY}`
    const w = (window as unknown) as WindowRecord
    if (w[winKey]) return w[winKey]

    const raw = uuidv4Fallback()
    const id = String(raw).toUpperCase()
    const value = `uuid:${id}`
    w[winKey] = value
    return value
  }
}

export const appendLsidToUrl = (url: string): string => {
  if (!url) return url
  // avoid duplicating param
  if (/([?&])lsid=/.test(url)) return url

  const hashIndex = url.indexOf('#')
  const beforeHash = hashIndex === -1 ? url : url.slice(0, hashIndex)
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex)
  const sep = beforeHash.includes('?') ? '&' : '?'
  const lsid = getOrCreateLSID()
  const appended = `${beforeHash}${sep}lsid=${encodeURIComponent(lsid)}`
  return `${appended}${hash}`
}
